module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00083-fs8.747411a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00083-fs8.png
// module id = 236
// module chunks = 0